import * as config from '../config';
import JumpModel from '../models/jump';

export default class JumpsController {
  constructor(stepsController, stepModel) {
    this.stepsController = stepsController;
    this.step = stepModel;
    this.jump = {};
  }

  draw() {
    this.step.jumps.forEach(jump => {
      this.jump = new JumpModel(this.step, jump);
      this.stepsController.style.bindIdToClass(this.jump.id, config.STEP_JUMP_CLASS);

      if (this.step.isEmail()) {
        return this.drawKindEmail();
      }

      if (this.shouldDrawConnection(jump)) {
        this.stepsController.graph.addNode(this.jump.id, this.jump.label);
        this.stepsController.graph.addEdge(this.step.id, this.jump.id);

        this.drawConnection(this.jump.id);
      }

      return true;
    });

    return true;
  }

  show() {
    return this.step.jumps && this.step.jumps.filter(jump => jump.destination_step_id).length;
  }

  drawKindEmail() {
    if (this.step.isRedirectEmailService()) {
      return false;
    }

    return this.drawConnection(this.step.id);
  }

  drawConnection(originId) {
    const destinationId = this.stepsController.getNextId(this.step, this.jump);

    if (destinationId) {
      this.stepsController.graph.addEdge(originId, destinationId);
    }
  }

  shouldDrawConnection(jump) {
    if (this.step.multiple_answers) {
      return true;
    }

    if (jump.options_ids !== null) {
      return true;
    }

    return this.step.optionsIds.sort().join() !== this.step.jumpOptionsIds.sort().join();
  }
}



/** WEBPACK FOOTER **
 ** ./src/helpers/fluxogram/controllers/jumps.js
 **/